export default __webpack_public_path__ + "static/media/triangulos.0792d517.png";